import React, { useEffect } from "react";

import { withSelectedCars } from "../../../shared/containers/containerSelectedCars";
import { withReportCar } from "../../../shared/containers/containerReportCar";

import ContentInnerWrapper from "../../../shared/contentInnerWrapper";
import Notification from "../../../shared/items/static/notification";
import SelectedCarItem from "./selectedCarItem";
import Scrollbars from "react-custom-scrollbars-2";
import styles from "./selectedCarsList.module.scss";

const REPORT_CARS_TITLE = "Выбранные автомобили";
const REPORT_CARS_TITLE_NULL = "Выберите один или несколько автомобилей";

const deleteCar = (props, carId) => {
  const { selectedCars, onChangeSelectedCar } = props;
  let updatedCars = [...selectedCars];
  let carIndex = selectedCars.findIndex((item) => item.id === carId);
  updatedCars.splice(carIndex, 1);

  onChangeSelectedCar(updatedCars);
};

const handleChangeCar = (props, id) => {
  const { onChangeReportCar } = props;

  onChangeReportCar(id);
};

const SelectedCarsList = (props) => {
  const { selectedCars, reportCarId, onClearReportCar } = props;

  useEffect(() => {
    if (selectedCars.length > 0 && !!reportCarId) {
      let isActiveCar = selectedCars.find((item) => item.id === reportCarId);

      if (!isActiveCar) handleChangeCar(props, selectedCars[0].id);
    }

    if (selectedCars.length > 0 && !reportCarId) handleChangeCar(props, selectedCars[0].id);

    if (selectedCars.length === 0 && reportCarId) onClearReportCar();
  }, [selectedCars]);

  const get = (selectedCars) => {
    return selectedCars.map((item) => {
      return (
        <div key={item.id}>
          <SelectedCarItem
            id={item.id}
            title={item.title}
            registerNumber={item.registerNumber}
            color={item.color}
            isActive={!!reportCarId && reportCarId === item.id}
            handleClick={handleChangeCar.bind(this, props, item.id)}
            deleteCar={deleteCar.bind(this, props, item.id)}
          />
        </div>
      );
    });
  };

  return (
    <ContentInnerWrapper title={REPORT_CARS_TITLE}>
      <div className={styles.container_selectedCarsList}>
        {selectedCars.length > 0 ? (
          <Scrollbars style={{ height: "100px" }} autoHide={true}>
            <div className={styles.selectedCarsList}>{get(selectedCars)}</div>
          </Scrollbars>
        ) : (
          <Notification type="warning">{REPORT_CARS_TITLE_NULL}</Notification>
        )}
      </div>
    </ContentInnerWrapper>
  );
};

export default withReportCar(withSelectedCars(React.memo(SelectedCarsList)));
